import styled from 'styled-components';

import { ContentSpacing, Colors } from '@estee/elc-base-theme';
import { Subtitle2 } from '@estee/elc-typography';
import { LockIcon } from '~views/Shared/Icons/LockIcon';
import { Button } from '@estee/elc-buttons';

import { defaultCTA, inheritBaseFont } from '~theme/default-theme';

const { space16, space8, space4 } = ContentSpacing;

export const LockIconWrapper = styled(LockIcon)`
    width: 14px;
    height: 14px;
    background-color: ${Colors.white};
    margin-right: ${space8};
    margin-bottom: ${space4};
`;

export const SubtotalValueWrapper = styled(Subtitle2)`
    margin-right: ${space16};
    ${inheritBaseFont};
`;

export const SubtotalLabelWrapper = styled(Subtitle2)`
    margin-left: ${space16};
    ${inheritBaseFont};
`;

export const StyledCheckoutLabel = styled(Subtitle2)`
    ${inheritBaseFont};
    color: ${Colors.white};
`;

export const CheckoutButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledButton = styled(Button)`
    ${defaultCTA};
    ${inheritBaseFont};
`;

export const StyledActionButton = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    max-height: 48px;
    min-height: 60px;
    flex: 1;
    flex-shrink: 0;
    ${inheritBaseFont};

    &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
    }
    .elc-icon {
        display: none;
    }
`;

export const StyledActionButtonLabel = styled.span`
    ${inheritBaseFont};
`;
